var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3396 21475)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3396 -21475)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 63.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3431.823-21391.578c2.285,4.762,39.173,39.816,71.69-.559",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 9,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFace);
export default __webpack_public_path__ + "static/media/greenFace.62047087f76004b8fc699a36403f10d2.svg";
export { ForwardRef as ReactComponent };